import { EBuildingClassType } from '../../../../json_query';
import { changeWarehouseBuildingClass } from '../../../state/advanced/building_class_warehouse';
import { getMultiSelectParam } from './abstract_params/multi_select_param';

export const WarehouseBuildingClass = getMultiSelectParam<EBuildingClassType>(
  'Класс',
  [
    { title: 'A', value: EBuildingClassType.A },
    { title: 'B', value: EBuildingClassType.B },
    { title: 'C', value: EBuildingClassType.C },
    { title: 'D', value: EBuildingClassType.D },
  ],
  'building_class_type__warehouse',
  changeWarehouseBuildingClass,
);
